<mat-spinner diameter="25"></mat-spinner>
<span>{{ 'MAIN.LOADING_SNACKBAR' | translate }}...</span>
